module.exports = __webpack_public_path__ + "img/playne-arrow-dte.bebc05a7.svg";